import { Component } from '@angular/core';
import { PaypalOrderComponent } from '../paypal/order/order.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pay',
    imports: [PaypalOrderComponent],
    templateUrl: './pay.component.html',
    styleUrl: './pay.component.css'
})
export class PayComponent {

  registrationId: string | null = null;
  
  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    this.registrationId = navigation?.extras.state?.['registrationId'] ?? null;
    console.log('Received registrationId:', this.registrationId);
  }
}
